/**
 * Format a staff display name for PO logs and UI.
 * Preferred: first name + last initial (e.g. "Mark D").
 */
export function formatUserDisplayName(user = {}) {
  const email = String(user.email || '').trim().toLowerCase();
  const emailPrefix = email.includes('@') ? email.split('@')[0] : '';
  const firstName = String(user.firstName || '').trim();
  const lastName = String(user.lastName || '').trim();
  const legacyName = String(user.name || '').trim();

  if (firstName && lastName) {
    return `${firstName} ${lastName.charAt(0).toUpperCase()}`;
  }
  if (firstName) {
    return firstName;
  }
  if (legacyName && legacyName !== emailPrefix) {
    return legacyName;
  }
  if (emailPrefix) {
    return emailPrefix;
  }
  return 'User';
}

export function resolveUserLabel(completedBy, completedByName, userNames = {}) {
  if (completedByName) return completedByName;
  const email = String(completedBy || '').trim().toLowerCase();
  if (email && userNames[email]) return userNames[email];
  if (email.includes('@')) return email.split('@')[0];
  return completedBy || null;
}
